export default {
  note: {
    title: 'Special notes:',
    description: 'We’ll try our best to accommodate requests, but can’t make changes that affect pricing.',
    placeholder: 'Add special request',
  },
  buttons: {
    add: '+ Add Item',
    update_item: 'Update',
    add_to_card: 'Add to cart',
  },
  alcohol_warning: 'This is an age-restricted article.',
  caffeine_warning: 'Increased caffeine content. Not recommended for children or pregnant or breastfeeding women.',
  error_messages: {
    missing_fields: 'Please select all required fields.',
    product_unavailable: 'Sold out!',
  },
  success_messages: {
    item_added: 'Item added successfully',
  },
  labels: {
    bogo: 'Buy One, Get One Free',
  },
};
